import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19694b72"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-method" }
const _hoisted_2 = { class: "section-1" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, [
  /*#__PURE__*/_createTextVNode(" 원더플 피플이 되기 위한"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 수거 가이드 ")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc" }, [
  /*#__PURE__*/_createTextVNode(" 다 마신 페트병은 재생 페트병이 되어 돌아올 수 있다고!"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("strong", null, "그렇담, 보틀투보틀을 위해 원더플 피플이 할 일은?"),
  /*#__PURE__*/_createElementVNode("br", { class: "d-block d-md-none" }),
  /*#__PURE__*/_createTextVNode(" 페트병을 올바르게 분리배출하는 일뿐!"),
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc" }, [
  /*#__PURE__*/_createTextVNode(" 원더플 피플!"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 우리 분리배출부터 차근차근 제대로 해보자구요. ")
], -1))
const _hoisted_6 = { class: "box-step" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box-step-title" }, " 올바른 분리배출법 ", -1))
const _hoisted_8 = { class: "steps" }
const _hoisted_9 = { class: "step-item step-item-1" }
const _hoisted_10 = { class: "box-img" }
const _hoisted_11 = ["src"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "order-num" }, "1. "),
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createTextVNode(" 내용물을 비운 후 "),
    /*#__PURE__*/_createElementVNode("br", { class: "d-none d-md-block" }),
    /*#__PURE__*/_createTextVNode("깨끗하게 헹구기 ")
  ])
], -1))
const _hoisted_13 = { class: "step-item step-item-2" }
const _hoisted_14 = { class: "box-img" }
const _hoisted_15 = ["src"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "order-num" }, "2. "),
  /*#__PURE__*/_createElementVNode("span", null, " 라벨 제거 후 말리기 ")
], -1))
const _hoisted_17 = { class: "step-item step-item-3" }
const _hoisted_18 = { class: "box-img" }
const _hoisted_19 = ["src"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "order-num" }, "3. "),
  /*#__PURE__*/_createElementVNode("span", null, " 압착 후 뚜껑 닫기 ")
], -1))
const _hoisted_21 = { class: "section-2" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, " 수거 품목 ", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-subtitle" }, " 투명 음료 페트병만 수거 가능해요! ", -1))
const _hoisted_24 = { class: "tab-1" }
const _hoisted_25 = ["src"]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc" }, " 생수 페트병, 음료 페트병(탄산, 이온, 주스 등), 주류 페트병 ", -1))
const _hoisted_27 = { class: "qa-container" }
const _hoisted_28 = { class: "box-qa" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "q" }, " 투명 음료 페트병인지 아닌지 헷갈린다면? ", -1))
const _hoisted_30 = { class: "a" }
const _hoisted_31 = ["src"]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "‘무색페트’ 분리배출 마크를 찾아보세요.", -1))
const _hoisted_33 = { class: "tab-2" }
const _hoisted_34 = ["srcset", "media"]
const _hoisted_35 = ["src"]
const _hoisted_36 = { class: "desc" }
const _hoisted_37 = { class: "section-3" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, " 수거 신청 방법 ", -1))
const _hoisted_39 = { class: "swiper-wrapper" }
const _hoisted_40 = { class: "box-slide" }
const _hoisted_41 = { class: "box-img" }
const _hoisted_42 = ["src"]
const _hoisted_43 = ["innerHTML"]
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "swiper-pagination" }, null, -1))
const _hoisted_45 = { class: "section-4" }

import SwiperComponent from 'swiper';
import { Pagination } from 'swiper/modules';
import { type ComputedRef, inject, onMounted, ref } from 'vue';
import Bg from './bg.vue';
import Desc from './desc.vue';
import SideBottle from './side-bottle.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

_useCssVars(_ctx => ({
  "66bfaaea": (tab1Bg),
  "66bfa368": (tab2Bg)
}))

const images = inject<ComputedRef<Record<string, string>>>('images')!;

const slides = [
  {
    desc: '동봉된 비닐을 <br class="d-none d-md-block">제로 웨이스트 박스에 <br>넣은 뒤 페트병 채우기<br>(비닐도 모두 재활용돼요.)',
    img: images.value['method-img-1']
  },
  {
    desc: '박스가 열리지 않도록 <br>테이프로 밀봉하기<br>(가볍게 밀봉해주셔도 돼요.)',
    img: images.value['method-img-2']
  },
  {
    desc: '수거 신청하기<br>박스 상단 QR코드 스캔 or <br>캠페인 페이지 직접 접속하기',
    img: images.value['method-img-3']
  },
  {
    desc: '등록한 주소지에 박스 놓고<br>택배 방문 수거 기다리기<br>(수거 신청 후 3~4일 이내에 <br class="d-none d-md-block">택배 <br class="d-block d-md-none">기사님이 방문하여 <br class="d-none d-md-block">수거하실 거예요.)',
    img: images.value['method-img-4']
  }
];

const tab2Desc = [
  '페트 외 플라스틱: <br class="d-block d-md-none">배달용기, 일회용 플라스틱컵, 담금주 통 등',
  '비음료 페트병: 엔진세정제, 구강세정제, 식용유, 물엿 등',
  '양념류나 식용유 등이 담긴 페트병은 완벽하게 <br class="d-block d-md-none">세척이 어려워 재활용 과정에서 <br class="d-none d-md-block">이물질이 들어갈 수 있어요.'
];

const section4Desc = [
  '수거 신청하는 제로 웨이스트 박스 수량 정확히 선택하기 <br class="d-block d-md-none">(박스 수량만큼 택배 송장이 필요하거든요!)',
  '박스 하나씩 수거 신청하기? <br class="d-block d-md-none">여러 개 한번에 수거 신청하기? 모두 가능!',
  '최소 제로 웨이스트 박스 표시선까지 페트병 채우기'
];
const swiperRef = ref<HTMLDivElement>();
onMounted(() => {
  new SwiperComponent(swiperRef.value!, {
    slidesPerView: 1.36,
    spaceBetween: 0,
    modules: [
      Pagination,
    ],
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      768: {
        pagination: false,
        slidesPerView: 4,
      },
    }
  });
});

const tab1Bg = `url('${images.value['method-tab-1-bg']}')`;
const tab2Bg = `url('${images.value['method-tab-2-bg']}')`;

return (_ctx: any,_cache: any) => {
  const _component_AppTab = _resolveComponent("AppTab")!
  const _component_AppTabs = _resolveComponent("AppTabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createVNode(SideBottle),
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("ul", _hoisted_8, [
          _createElementVNode("li", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("img", {
                src: _unref(images)['method-step-1']
              }, null, 8, _hoisted_11)
            ]),
            _hoisted_12
          ]),
          _createElementVNode("li", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("img", {
                src: _unref(images)['method-step-2']
              }, null, 8, _hoisted_15)
            ]),
            _hoisted_16
          ]),
          _createElementVNode("li", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("img", {
                src: _unref(images)['method-step-3']
              }, null, 8, _hoisted_19)
            ]),
            _hoisted_20
          ])
        ])
      ])
    ]),
    _createVNode(Bg, null, {
      default: _withCtx(() => [
        _createElementVNode("section", _hoisted_21, [
          _hoisted_22,
          _hoisted_23,
          _createVNode(_component_AppTabs, { class: "tabs" }, {
            default: _withCtx(() => [
              _createVNode(_component_AppTab, { label: "수거 가능 품목" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("img", {
                      src: _unref(images)['method-tab-1-img']
                    }, null, 8, _hoisted_25),
                    _hoisted_26,
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _hoisted_29,
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("img", {
                            src: _unref(images)['icon-recycle']
                          }, null, 8, _hoisted_31),
                          _hoisted_32
                        ])
                      ])
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_AppTab, { label: "수거 불가 품목" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("picture", null, [
                      _createElementVNode("source", {
                        srcset: _unref(images)['method-tab-2-img'],
                        media: `(max-width: ${768}px)`
                      }, null, 8, _hoisted_34),
                      _createElementVNode("img", {
                        src: _unref(images)['method-tab-2-img-pc'],
                        alt: ""
                      }, null, 8, _hoisted_35)
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      _createVNode(Desc, {
                        title: "주의!",
                        value: tab2Desc
                      })
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    _createElementVNode("section", _hoisted_37, [
      _hoisted_38,
      _createElementVNode("div", {
        ref_key: "swiperRef",
        ref: swiperRef,
        class: "swiper"
      }, [
        _createElementVNode("div", _hoisted_39, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(slides, (item, index) => {
            return _createElementVNode("div", {
              key: index,
              class: "swiper-slide"
            }, [
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("img", {
                    src: item.img
                  }, null, 8, _hoisted_42)
                ]),
                _createElementVNode("div", {
                  class: "desc",
                  innerHTML: item.desc
                }, null, 8, _hoisted_43)
              ])
            ])
          }), 64))
        ]),
        _hoisted_44
      ], 512)
    ]),
    _createElementVNode("section", _hoisted_45, [
      _createVNode(Desc, {
        title: "수거 신청 전 확인 필수!",
        value: section4Desc
      })
    ])
  ]))
}
}

})